export function formatNumberDecimal(num, decimals = 2) {
    return parseFloat(num.toFixed(decimals));
}